import { render, staticRenderFns } from "./B2CTraHang.vue?vue&type=template&id=5e608241"
import script from "./B2CTraHang.vue?vue&type=script&lang=js"
export * from "./B2CTraHang.vue?vue&type=script&lang=js"
import style0 from "./B2CTraHang.vue?vue&type=style&index=0&id=5e608241&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports